// extracted by mini-css-extract-plugin
var _1 = "PostResultCard-module__animateUploadProgressBarWidth--b0K_M";
var _2 = "PostResultCard-module__animatedBackground--bR18I";
var _3 = "PostResultCard-module__bottomMeta--dX2Tf";
var _4 = "PostResultCard-module__contributors--VlmQS";
var _5 = "PostResultCard-module__footer--Eq0bq";
var _6 = "PostResultCard-module__hoverTarget--kSiUc";
var _7 = "PostResultCard-module__icon--vMpYM";
var _8 = "PostResultCard-module__metaList--fpzHL";
var _9 = "PostResultCard-module__right--B55OP";
var _a = "PostResultCard-module__seriesContainer--g8Izb";
var _b = "PostResultCard-module__viewedAtIcon--n9LQa";
var _c = "PostResultCard-module__viewedMeta--bgb7A";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "bottomMeta", _4 as "contributors", _5 as "footer", _6 as "hoverTarget", _7 as "icon", _8 as "metaList", _9 as "right", _a as "seriesContainer", _b as "viewedAtIcon", _c as "viewedMeta" }
